/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_oauth_complete_button_try_again = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const zh_hans1_oauth_complete_button_try_again = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const zh_hant1_oauth_complete_button_try_again = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試一次`)
};

const fr_oauth_complete_button_try_again = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const de_oauth_complete_button_try_again = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const ja_oauth_complete_button_try_again = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試行`)
};

const ko_oauth_complete_button_try_again = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 시도`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const oauth_complete_button_try_again = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oauth_complete_button_try_again(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oauth_complete_button_try_again", locale)
	if (locale === "en") return en_oauth_complete_button_try_again(inputs)
	if (locale === "zh-Hans") return zh_hans1_oauth_complete_button_try_again(inputs)
	if (locale === "zh-Hant") return zh_hant1_oauth_complete_button_try_again(inputs)
	if (locale === "fr") return fr_oauth_complete_button_try_again(inputs)
	if (locale === "de") return de_oauth_complete_button_try_again(inputs)
	if (locale === "ja") return ja_oauth_complete_button_try_again(inputs)
	return ko_oauth_complete_button_try_again(inputs)
};